
import { hydrateCSRTemplate } from '@fiverr-private/layout_lib/CSRTemplate';
import { handleCSRError } from '@fiverr-private/layout_lib/CSRTemplate';
import { loader } from '/home/circleci/app/packages/layout-footer-component/src/entries/Default';
const getRootElement = () => typeof document !== 'undefined' && document.querySelector('#Footer');
const lazyImport = () => import(
    /* webpackChunkName: "DefaultLazyComponent" */
    /* webpackExports: ["default"] */
    '/home/circleci/app/packages/layout-footer-component/src/entries/Default?version=1'
);
const hydrateComponent = async () => {
    try {
        const { default: Component } = await lazyImport();
        const props = window.initialData['Footer'];
        const root = getRootElement();
        if (root) {
            hydrateCSRTemplate(Component, props, root, 'Footer', 'Default');
        }
    } catch(error) {
        handleCSRError(error, "Footer", "Default");
    }
};
const main = async () => {
    try {
        const root = getRootElement();
        if (root) {
            await loader(hydrateComponent, root);
        }
    } catch(error) {
        handleCSRError(error, "Footer", "Default");
    }
};
main();
export default main;
